import { render, staticRenderFns } from "./TextH3.vue?vue&type=template&id=5bef1fa0"
import script from "./TextH3.vue?vue&type=script&lang=js"
export * from "./TextH3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports